module.exports = __webpack_public_path__ + "img/sankaku_49_red.e6553073.png";